import React, { useState } from "react";
import Image from "../elements/Image";
import Button from "../form/front/Button";
import { classNames } from "../../helpers/classNames";

const SingleJobCard = ({ data, onClick, isSelected }) => {
  const [isSaved, setIsSaved] = useState(false);
  // const [isSelected, setIsSelected] = useState(false);

  const checkboxId = `job-card-${data?.id}`;

  return (
    <div className="relative">
      <input
        type="checkbox"
        id={checkboxId}
        checked={isSelected}
        onChange={() => onClick(data)}
        className="peer hidden"
      />

      <label
        htmlFor={checkboxId}
        className={classNames(
          "relative flex-shrink flex-grow py-3 px-4 flex md:flex-row flex-col gap-2 md:gap-3 cursor-pointer border-b border-gray-200 transition-all duration-200","hover:bg-gray-100",
          "before:absolute before:left-0 before:top-0 before:h-full before:w-[2px] before:bg-palatte before:transition-all before:duration-200",
          isSelected
            ? "before:scale-y-100 bg-gray-50"
            : "before:scale-y-0"
        )}
      >
        {data?.image && (
          <div className={classNames("w-14 rounded-md aspect-square overflow-hidden flex-shrink-0  p-1", isSelected ? "bg-white" : "bg-gray-100")}>
            <Image
              src={data?.image}
              alt={data?.title || "logo"}
              classes="object-contain w-full"
            />
          </div>
        )}

        <div className="flex-shrink flex-grow space-y-0.5">
          {data?.title && (
            <div className="text-black dark:text-gray-100 text-sm lg:text-sm capitalize font-bold line-clamp-2 leading-none">
              {data?.title}
            </div>
          )}
          {data?.subtitle && (
            <div className="text-sm text-slate-600 dark:text-gray-200 font-semibold line-clamp-2">
              {data?.subtitle}
            </div>
          )}
          {data?.description && (
            <div
              className="text-xs text-slate-600 dark:text-gray-300 space-y-1 line-clamp-2 pb-1"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            />
          )}

          {/* <div className="flex items-center space-x-2">
            {data?.jobType && (
              <div className="bg-purple-100 rounded-md h-8 flex items-center">
                <div className="text-palatte text-sm font-bold capitalize px-4">
                  {data?.jobType}
                </div>
              </div>
            )}

            {data?.workMode && (
              <div className="bg-teal-100 rounded-md h-8 flex items-center">
                <div className="text-teal-700 text-sm font-bold capitalize px-4">
                  {data?.workMode}
                </div>
              </div>
            )}
          </div> */}
        </div>

        {/* <div className="absolute right-6 top-4">
          <Button
            buttonLabel="save job"
            buttonLabelClasses="capitalize text-sm font-semibold group-hover:text-white"
            buttonIcon={
              isSaved ? "fa-solid fa-bookmark" : "fa-regular fa-bookmark"
            }
            buttonIconPosition="right"
            buttonFunction={() => {
              if (!isSelected) {
                setIsSaved((prev) => !prev);
              }
            }}
            buttonClasses={classNames(
              "h-9 border border-palatte4 text-sm group transition-all",
              isSaved
                ? "bg-palatte4 text-white"
                : "bg-white text-palatte4 hover:bg-palatte4 hover:text-white",
            )}
          />
        </div> */}
      </label>
    </div>
  );
};

export default SingleJobCard;
